<span [ngClass]="'wuc-text-highlight--' + type">
  <ng-content></ng-content>
</span>
